export enum InputStyleEnum {
  Default = 'default',
  Shadowed = 'shadowed',
  Transparent = 'transparent',
}
